import { CategoryDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/category_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type CategoryDeletedDetailProps = {
  event: CategoryDeletedEvent;
};

export const CategoryDeletedDetail = ({
  event,
}: CategoryDeletedDetailProps) => {
  const category = event.category;

  if (!category) {
    return (
      <Col className="@CategoryDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const attributes = category.attributes as Record<string, unknown> | undefined;
  const attributesCount = attributes ? Object.keys(attributes).length : 0;

  return (
    <Col className="@CategoryDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Category
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={category.id?.value} />
          <FieldDisplay label="Name" value={category.name} />
          <FieldDisplay label="Description" value={category.description} />
          <IDField
            label="Organization ID"
            value={category.base?.organizationId?.value}
          />
          <FieldDisplay
            label="Attributes Count"
            value={String(attributesCount)}
          />
        </div>
      </Col>
    </Col>
  );
};
